import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f5bb90b&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=0f5bb90b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5bb90b",
  null
  
)

export default component.exports